import { render, staticRenderFns } from "./terms-conditions.vue?vue&type=template&id=0e27a110&scoped=true&"
import script from "./terms-conditions.vue?vue&type=script&lang=js&"
export * from "./terms-conditions.vue?vue&type=script&lang=js&"
import style0 from "./terms-conditions.vue?vue&type=style&index=0&id=0e27a110&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e27a110",
  null
  
)

export default component.exports